import { Component, OnInit } from '@angular/core';
import { ReportService } from '../Services/report.service';
import { AuthService } from '../Services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { Logininfo } from '../classes/Loginifo';

@Component({
	selector: 'app-report-list',
	templateUrl: './report-list.component.html',
	styleUrls: ['../report/report.component.css']
})

export class ReportListComponent implements OnInit {
	logininfo: Logininfo = this.Auth.loginID;
	year;
	month;
	list: any[];
	weeks: any = [];
	weeklen = 0;
	years = [];
	minyear = 2019;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private DBserivice: ReportService,
		public Auth: AuthService,
	) { }

	ngOnInit() {
		if (this.DBserivice.year && this.DBserivice.month) {
			this.year = this.DBserivice.year;
			this.month = this.DBserivice.month;
		} else {
			this.year = new Date().getFullYear();
			this.month = new Date().getMonth() + 1;
		}
		this.mkYeasList();
		this.initWeek();
	}
	mkYeasList() {
		var year = new Date().getFullYear();
		var length = (year - this.minyear) + 1;
		var list = Array.apply(null, new Array(length)).map(function (v, i) { return year - i });

		this.years = [];
		list.forEach(val => {
			let y = { value: val, text: val + '年' };
			this.years.push(y);
		});
	}

	initWeek() {
		this.list = [];
		this.weeks = this.getWeekNo(this.year, this.month);
		this.weeklen = this.weeks.length;

		this.DBserivice.getWeeklyList(this.year, this.month).subscribe(			//週報取得
			list => {
				this.createList(list);
			});

	}


	//リスト生成
	createList(reportList) {
		let userslist = [];
		let report = [];


		this.Auth.getUserList(0, 1, 0, 0).subscribe(userlist => {					//ユーザーリスト取得
			for (let user in userlist) {
				let last_filing = { date: null, week: null };						//最終更新日
				report = [];
				for (let index = 1; index <= this.weeklen; index++) {
					report.push({
						week: index,
						filing_date: null
					})
				}

				//レポート一覧生成
				reportList.forEach(item => {
					if (userlist[user].user_code == item.user_code) {
						report[item.week - 1] = {
							week: item.week,
							filing: item.filing_date,
						}
						if (item.filing_date)
							last_filing = { date: item.filing_date, week: item.week };
					}
				});

				let userReport = {
					user_code: userlist[user].user_code,
					name: userlist[user].user_family_name + ' ' + userlist[user].user_name,
					report: report,
					last_filing: last_filing,
				}
				userslist.push(userReport);
			}
			this.list = userslist;
		});
	}

	edit(user_code, week) {
		this.DBserivice.year = this.year;
		this.DBserivice.month = this.month;
		this.router.navigate(['/report-edit', user_code, this.year, this.month, week], { relativeTo: this.route });
	}
	show(user_code, week) {
		this.DBserivice.year = this.year;
		this.DBserivice.month = this.month;
		this.router.navigate(['/report', user_code, this.year, this.month, week], { relativeTo: this.route });
	}


	//指定月の週情報
	getWeekNo(year, month) {
		let now = new Date(year, month - 1, 1);
		let dt = new Date(year, month - 1, 1);

		// dtを指定月の最初の週の開始日にする
		let mon = dt.getDay();
		if (mon > 1) {
			dt.setDate(dt.getDate() + (8 - dt.getDay()));
		} else if (mon == 0) {
			dt.setDate(dt.getDate() + 1)
		}

		let weeksOfMonth = [];
		let weekNo = 1;
		while (dt.getMonth() == now.getMonth()) {
			weeksOfMonth.push({ week: weekNo++, 'start': new Date(dt), 'end': new Date(dt.setDate(dt.getDate() + 6)) });
			dt.setDate(dt.getDate() + 1);
		}
		return weeksOfMonth;
	}
}
